/**
 * Límite de adjuntos al redactar, responder o reenviar correos.
 *
 * Solo importa el peso total del correo: no hay tope por archivo ni por
 * cantidad, así que un solo archivo puede ocupar los 25 MB. Debe coincidir
 * con `src/config/attachmentLimits.ts` del backend de correo, que es quien
 * rechaza definitivamente (413).
 */
export const EMAIL_ATTACHMENT_TOTAL_LIMIT_MB = 25

export const EMAIL_ATTACHMENT_TOTAL_LIMIT_BYTES = EMAIL_ATTACHMENT_TOTAL_LIMIT_MB * 1024 * 1024

/** Correos que se pueden adjuntar por referencia en un mismo mensaje. Debe coincidir con
 * `MAX_ATTACHED_EMAILS` de `src/utils/attachedEmails.ts` del backend de correo. */
export const MAX_ATTACHED_EMAILS = 10
